function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 5.45459,
  y: 2.72726,
  width: 16.3636,
  height: 21.8182,
  stroke: "#FFFFFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.8182 4.09091H24.5455V27.2727H8.18188V25.2273",
  stroke: "#FFFFFF"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 8.18188,
  y: 5.45456,
  width: 5.45455,
  height: 2.72727,
  stroke: "#FFFFFF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3635 5.45456H19.0908",
  stroke: "#FFFFFF",
  strokeLinecap: "square"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3635 8.18182H19.0908",
  stroke: "#FFFFFF",
  strokeLinecap: "square"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M8.18188 12.2727H19.091",
  stroke: "#FFFFFF",
  strokeLinecap: "square"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M8.18188 15H19.091",
  stroke: "#FFFFFF",
  strokeLinecap: "square"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M8.18188 17.7273H19.091",
  stroke: "#FFFFFF",
  strokeLinecap: "square"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M8.18188 20.4546H19.091",
  stroke: "#FFFFFF",
  strokeLinecap: "square"
});

var SvgPlaquette = function SvgPlaquette(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlaquette, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plaquette.195f7b0f.svg";
export { ForwardRef as ReactComponent };